import React from 'react';
import { styled } from 'styled-components';
import { TextField, Icon } from '@sunwebgroup/ui-components';
import { useIntl } from '@/intl';

const SearchFieldWrapper = styled(TextField.Root)`
  margin-bottom: 8px;
  max-width: 480px;
`;

export interface TableSearchProps {
  searchTerm: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function TableSearch({ searchTerm, onSearchChange }: TableSearchProps) {
  const intl = useIntl();
  return (
    <SearchFieldWrapper>
      <TextField.Leading>
        <Icon glyph="IconSearch" size="sm" />
      </TextField.Leading>
      <TextField.Content>
        <TextField.Input
          value={searchTerm}
          placeholder={intl.formatMessage({ id: 'live-search_search_button_text' })}
          type="text"
          onChange={onSearchChange}
        />
      </TextField.Content>
    </SearchFieldWrapper>
  );
}
